export default {
    url: '',
    template: `
        <div class="col00">
            <ui-view></ui-view>
        </div>
    `,
    resolve: {
        sites (SiteResource) {
            return SiteResource.query({ pageSize: 0 }).$promise;
        },
        courses: (CourseResource, sites) => {
            return CourseResource.getCourses(
                {
                    expand: 'activeI18n',
                    fields: 'id', // expand fields will be included by default
                    pageSize: 2000
                },
                {
                    'courseAccessSiteIds[]': sites.map(site => site.id)
                }
            ).$promise;
        }
    },
    controller (sites, courses) {
        this.sites = sites;
        this.courses = courses;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/events/index.js